import React, { useState } from 'react'
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  IconButton, 
  Box, 
  Avatar, 
  Menu, 
  MenuItem, 
  Divider,
  useTheme,
  Tabs,
  Tab
} from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import PersonIcon from '@mui/icons-material/Person'
import LogoutIcon from '@mui/icons-material/Logout'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ChatIcon from '@mui/icons-material/Chat'
import SettingsIcon from '@mui/icons-material/Settings'
import ReceiptIcon from '@mui/icons-material/Receipt'
import MenuIcon from '@mui/icons-material/Menu'
import MoreVertIcon from '@mui/icons-material/MoreVert'

const Header = ({
  activeTab,
  onTabChange,
  isMobile,
  onMenuClick,
  onMobileMenuClick,
  mobileMenuAnchor,
  onMobileMenuClose,
  onMobileMenuSelect,
  onLogout
}) => {
  const { user } = useAuth()
  const theme = useTheme()
  
  const handleTabChange = (event, newValue) => {
    if (onTabChange) {
      onTabChange(newValue)
    }
  }
  
  if (!user) return null
  
  // Only show tabs for the main navigation items, not for settings
  const displayedTab = ['conversations', 'templates', 'fortnox'].includes(activeTab) ? activeTab : null;
  
  return (
    <AppBar 
      position="static" 
      color="inherit" 
      elevation={0}
      sx={{ 
        borderBottom: 1, 
        borderColor: 'divider',
        zIndex: (theme) => theme.zIndex.drawer + 1
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          
          <Typography 
            variant="h6" 
            component="div" 
            onClick={() => window.location.href = '/'}
            sx={{ 
              fontWeight: 'bold',
              background: 'linear-gradient(45deg, #4F46E5 30%, #818CF8 90%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mr: 4,
              cursor: 'pointer'
            }}
          >
            Relco Recensioner
          </Typography>
          
          {!isMobile && (
            <Tabs 
              value={displayedTab}
              onChange={handleTabChange}
              sx={{ 
                '& .MuiTab-root': {
                  minWidth: 'auto',
                  px: 2
                }
              }}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab 
                label="Konversationer" 
                value="conversations" 
                icon={<ChatIcon fontSize="small" />}
                iconPosition="start"
              />
              <Tab 
                label="Meddelandemallar" 
                value="templates" 
                icon={<SettingsIcon fontSize="small" />}
                iconPosition="start"
              />
              <Tab 
                label="Fortnox" 
                value="fortnox" 
                icon={<ReceiptIcon fontSize="small" />}
                iconPosition="start"
              />
            </Tabs>
          )}
        </Box>
        
        <Box>
          {isMobile ? (
            <>
              <IconButton
                edge="end"
                color="inherit"
                onClick={onMobileMenuClick}
                aria-label="more"
              >
                <MoreVertIcon />
              </IconButton>

              <Menu
                anchorEl={mobileMenuAnchor}
                open={Boolean(mobileMenuAnchor)}
                onClose={onMobileMenuClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => onMobileMenuSelect('conversations')}
                  selected={activeTab === 'conversations'}
                >
                  <ChatIcon fontSize="small" sx={{ mr: 1 }} />
                  Konversationer
                </MenuItem>
                <MenuItem
                  onClick={() => onMobileMenuSelect('templates')}
                  selected={activeTab === 'templates'}
                >
                  <SettingsIcon fontSize="small" sx={{ mr: 1 }} />
                  Meddelandemallar
                </MenuItem>
                <MenuItem
                  onClick={() => onMobileMenuSelect('fortnox')}
                  selected={activeTab === 'fortnox'}
                >
                  <ReceiptIcon fontSize="small" sx={{ mr: 1 }} />
                  Fortnox
                </MenuItem>
                <MenuItem
                  onClick={() => onMobileMenuSelect('settings')}
                  selected={activeTab === 'settings'}
                >
                  <SettingsIcon fontSize="small" sx={{ mr: 1 }} />
                  Inställningar
                </MenuItem>
                <Divider />
                <MenuItem onClick={onLogout}>
                  <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                  Logga ut
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <Button
                color="inherit"
                onClick={onMobileMenuClick}
                endIcon={<KeyboardArrowDownIcon />}
                startIcon={
                  <Avatar 
                    sx={{ 
                      width: 28, 
                      height: 28, 
                      bgcolor: theme.palette.primary.main,
                      fontSize: '0.8rem'
                    }}
                  >
                    <PersonIcon fontSize="small" />
                  </Avatar>
                }
                sx={{ 
                  textTransform: 'none',
                  fontWeight: 'normal'
                }}
              >
                {user.email}
              </Button>

              <Menu
                anchorEl={mobileMenuAnchor}
                open={Boolean(mobileMenuAnchor)}
                onClose={onMobileMenuClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => onMobileMenuSelect('settings')}
                >
                  <SettingsIcon fontSize="small" sx={{ mr: 1 }} />
                  Inställningar
                </MenuItem>
                <Divider />
                <MenuItem onClick={onLogout}>
                  <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                  Logga ut
                </MenuItem>
              </Menu>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Header 